import { useContext } from "react";

import { CustomerBlockContext } from "../context/CustomerBlockContext";

export const useCustomerBlockContext = () => useContext(CustomerBlockContext);
